import React from "react";
import {BsCircleFill} from "react-icons/bs";
import {Flex, Text, SimpleGrid} from "@chakra-ui/react";

export const indexColorMap = {
    0: "#1CB845",
    1: "#27BEF5",
    2: "#DE1D4A"
}
export const indexTextMap = {
    0: "Positive",
    1: "Neutral",
    2: "Negative",
    3: "All"
}

function SentimentSelectorButton({indexActive, index, setReviewSentiment}) {


    function handleClick() {
        setReviewSentiment(indexTextMap[index].toLowerCase());
    }

    return (
        <Flex onClick={handleClick} alignItems="center" bgColor={indexActive === index ? "#98D6FA" : "transparent"}
              borderRadius="13px" h="27px" p="3px" cursor="pointer">
            <BsCircleFill
                style={{color: indexColorMap[index], size: "1em", margin: "3px"}}/>
            <Text as="b">{indexTextMap[index]}</Text>
        </Flex>
    )
}


export default function SentimentSelector({reviewSentiment, setReviewSentiment}) {

    const textIndexMap = {
        "positive": 0,
        "neutral": 1,
        "negative": 2,
        "all": 3,
    }
    console.log("reviewSentiment", reviewSentiment);
    return (
        <Flex borderRadius="19px" bgColor="gray.200" h="38px" alignItems='center'>
            <SimpleGrid columns={4} spacing={9} mx="6px">
                <SentimentSelectorButton index={0} indexActive={textIndexMap[reviewSentiment]}
                                         setReviewSentiment={setReviewSentiment}/>
                <SentimentSelectorButton index={1} indexActive={textIndexMap[reviewSentiment]}
                                         setReviewSentiment={setReviewSentiment}/>
                <SentimentSelectorButton index={2} indexActive={textIndexMap[reviewSentiment]}
                                         setReviewSentiment={setReviewSentiment}/>
                <SentimentSelectorButton index={3} indexActive={textIndexMap[reviewSentiment]}
                                         setReviewSentiment={setReviewSentiment}/>
            </SimpleGrid>
        </Flex>
    )
}